module.exports = __webpack_public_path__ + "img/2.fc7cfe20.png";